import { AddressSearchResponseItem, AddressSearchResponseList } from '@/types/service-response'

export class Address {
  private constructor (
    readonly id: number,
    readonly name: string,
    readonly addressLinie: string
  ) {}

  public static createListFromResponse (data: AddressSearchResponseList): Address[] {
    return data.map((item: AddressSearchResponseItem): Address => {
      const addressNumber: string[] = item.Name.split(' ')
      return new Address(
        item.ID,
        item.Name,
        item.AdressLinie ? `${addressNumber[0]} - ${item.AdressLinie}` : item.Name
      )
    })
  }
}
